import Q16 from './Q16';

export default Q16;
